import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Col, Container, Row } from 'react-bootstrap'
import SelectDropDown from '../component/SelectDropDown';
import HelpDeskServices from '../services/HelpDesk';
import ThemeTextarea from '../component/ThemeTextarea';
import PrimaryGradientButton from '../component/PrimaryGradientButton';
import Loader from '../component/Loader';
import { useNavigate } from 'react-router-dom';
import AlertMsg from '../component/AlertMsg';
import toast from 'react-hot-toast';
import UploadFile from "../component/UploadFile";
import { localPersona, serverAssets } from '../constants/common';
import OrderService from '../services/Order';
import RegistrationService from '../services/registration';
import NoData from "../component/NoData";

const RaiseTicket = () => {
    const [loading, setLoading] = useState(true);
    const [isButtonLoading, setIsButtonLoading] = useState(false);
    const [isLoginSuccess, setIsLoginSuccess] = useState({ isLogin: true, heading: '', text: '' })
    const [showAlert, setShowAlert] = useState(false);
    const [complaintOptionData,setComplaintOptionData] = useState([]);
    const [isComplaint, setIsComplaint] = useState({ id: "", title: "" });
    const [isSubComplaint, setIsSubComplaint] = useState({ id: "", title: "" });
    const [isPriorty, setIsPriorty] = useState({ id: "", title: "" });
    const [isSummaryValidationError, setIsSummaryValidationError] = useState('')
    const [isIssueValidationError, setIsIssueValidationError] = useState('')
    const [isComplaintValidationError, setIsComplaintValidationError] = useState('')
    const [isSubComplaintValidationError, setIsSubComplaintValidationError] = useState('')
    const [isContractorValidationError, setIsContractorValidationError] = useState('')
    const [isPriorityValidationError, setIsPriorityValidationError] = useState('')
    const [raiseTicketInput, setRaiseTicketInput] = useState(
        {
           issueSummary:'',
           issueDetails:'' 
        }
    )
    const [image, setImage] = useState({ file: null, name: "", type: "" });
    const [fileInputKey, setFileInputKey] = useState(Date.now());
    const [hierId, setHierId] = useState('');
    const [orderRelatedIssue, setOrderRelatedIssue] = useState([]);
    const [myOrderList, setMyOrderList] = useState([]);
    const [contractorList, setContractorList] = useState([]);
    const [allSubcategory, setAllsubcategory] = useState([]);
    const [selectedSubComplaint, setSelectedSubComplaint] = useState({
        id: '',
        title: '',
    });
    const [allComplaint, setAllComplaint] = useState([]);
    const [selectedContractor, setSelectedContractor] = useState({
        id: '',
        title: '',
      });
    const [selectedOrder, setSelectedOrder] = useState({
        id: '',
        title: '',
      });
      const [isOrderValidationError, setIsOrderValidationError] = useState('');
      const [isFileValidationError, setIsFileValidationError] = useState('');
      

    const navigate = useNavigate()

    //Complaint Category//
    useEffect(()=>{
        const complaintDataFetch = async() =>{
            try{
            const payload = {
                "referanceId":"", // unused for
                "organizationId": 2, //*Mandatory
                "parentCategoryId": "", // optional
                "categoryCode" : "",
                "responseType" : "all"
            }
            const  complaintDataResponse = await HelpDeskServices.allCategories(payload)
            
            if(complaintDataResponse.apiStatus.message == 'success'){
                setComplaintOptionData(complaintDataResponse.response);
                const complaints = complaintDataResponse.response.map(item => ({
                    id: item.id,
                    title: item.name,
                    uniqueCode: item.unique_code,
                }));

                setAllComplaint(complaints);

                // setComplaintOptionData(complaintDataResponse.response?.map((item,index)=>{
                //     return{
                //         id:item.id,
                //         title:item.name
                //     }
                // }))
                setLoading(false)
            }
            }
            catch(error){
                console.error("Complaint Category List" )
            }
        }
        complaintDataFetch()
    },[])
    //Priority Level
    const allPriority = [
        {
          id: "0",
          title: "Low"
        },
        {
          id: "1",
          title: "High"
        },
      ]
    const handleCategorySelect = (selectedValue) => {
      setIsComplaint(selectedValue)
      setIsComplaintValidationError('')
      // Reset all fields below Complaint Category
      setIsSubComplaint({ id: "", title: "" })
      setSelectedContractor({ id: "", title: "" })
      setSelectedOrder({ id: "", title: "" })
      setRaiseTicketInput({ issueSummary: '', issueDetails: '' })
      setImage({ file: null, name: "", type: "" })
      setMyOrderList([])
      setFileInputKey(Date.now());
    }
    const handleSubCategorySelect = (selectedValue) => {
        setIsSubComplaint(selectedValue)
        setIsSubComplaintValidationError('')
    }
    const handleContractorSelect = (selectedValue) => {
        setSelectedContractor(selectedValue)
        setIsContractorValidationError('')
    }
    const handlePriortySelect = (selectedValue) => {
        setIsPriorty(selectedValue)
        setIsPriorityValidationError('')
    }
    const handleChangeInput = (e) =>{
        setRaiseTicketInput({...raiseTicketInput,[e.target.name]: e.target.value})
        switch(e.target.name){
            case 'issueDetails':
            setIsIssueValidationError('');
            break;
            case 'issueSummary':
            setIsSummaryValidationError('');
            break;
        }
    }

    const getContractorsForTSE = async () => {
        setLoading(true);
        try {
          const res = await RegistrationService.myAllContractorsTSE();
          if (res.success && res.response?.userDetails) {
            const datas = res.response.userDetails;
            const filteredData = datas
              .filter(
                (obj, index, self) =>
                  index === self.findIndex(t => t.id_extern01 === obj.id_extern01)
              )
              .map(user => ({
                id: user.contact_id,
                title: `${user.full_name} (M: ${user.phone_number})`,
                phoneNum: user.phone_number,
              }));
    
            setContractorList(filteredData);
          } else {
            // console.warn('Contractor fetch failed or no user details.');
            setLoading(false);
          }
        } catch (err) {
          console.error('Error fetching contractors:');
        } finally {
          setLoading(false);
        }
      };

    async function loadOrders() {
      try {
        const res = await OrderService.myOrderList();
        if (JSON.stringify(res) !== '{}' && !res.error) {
          const orders = res.data.map(product => ({
            id: product.order_id,
            title: `${product.product_name} (${product.order_id})`,
            unit: product.item_id,
            date: product.order_created_at,
            qty: product.item_quantity,
            points: product.item_total_points,
            image: product.product_image
              ? product.product_image
              : `${serverAssets}/noimage.png`,
          }));
          setMyOrderList(orders);
        } else {
          // console.warn('Invalid response structure or error in response', res);
        }
      } catch (error) {
        console.error('Failed to load orders:');
      } 
    }

    useEffect(() => {
        const userInfo = JSON.parse(localStorage.getItem("userData"));
        const hierId = userInfo.dcm_hierarchies_id;
        setHierId(hierId);
    }, []);

    // useEffect(() => {
    //     try {
    //             if(hierId){
    //                 const payloadConfig = {
    //                     configuration_name: 'orderRelatedProcessId',
    //                     hierarchy_id: hierId,
    //                 };

    //                 const res = HelpDeskServices.config(payloadConfig);

    //                 if(res.apiStatus.message == 'success'){

    //                     setOrderRelatedIssue(res?.data?.conf_value.split(','));
    //                 }
    //             }
                
    //         } catch (error) {
    //             console.error("Config ERR" )
    //         }
    // }, [hierId])
    useEffect(() => {
        const fetch = async() =>{
        try {
                if(hierId){
                    const payloadConfig = {
                        configuration_name: 'orderRelatedProcessId',
                        hierarchy_id: hierId,
                    };
                    
                    const res = await HelpDeskServices.config(payloadConfig);
                    if(res){
                        
                        setOrderRelatedIssue(res?.data?.conf_value.split(','));
                    }
                }
                
            } catch (error) {
                console.error("Config ERR" )
            }
           }
           fetch();
    }, [hierId])

    useEffect(() => {
        if(isComplaint?.id){
            let data = complaintOptionData.filter(item => {
                return item.id == isComplaint.id;
                // id: item.id,
                // title: item.name,
            })
            let subCategory = data[0]?.subCategories?.map(item => ({
                id: item.id,
                title: item.name,
            }));
            if(orderRelatedIssue.includes((data[0]?.dcm_processes_id).toString())){
                const userInfo = JSON.parse(localStorage.getItem("userData"));
                const desc = userInfo?.description;
                if(
                    desc == localPersona.Contractor || 
                    desc == localPersona.Bog || 
                    desc == localPersona.Dealer || 
                    desc == localPersona.ARS || 
                    desc == localPersona.Retailer
                ){
                  
                    loadOrders();
                }
                if(desc == localPersona.TSE){
                    getContractorsForTSE();
                }
            } else {
                setMyOrderList([]);
            }
            setAllsubcategory(subCategory);
        }
    }, [isComplaint]);

    const getInfluencerOrders = async () => {
      try {
        const payload = {
          contact_id: selectedContractor?.id,
        };
        const res = await OrderService.myInfluencerOrderList(payload);
        if (JSON.stringify(res) != '{}' && !res.error) {
          if (res.data.length > 0) {
            setMyOrderList(res.data.map(product => ({
              id: product.order_id,
              title: `${product.product_name} (${product.order_id})`,
              unit: product.item_id,
              date: product.order_created_at,
              qty: product.item_quantity,
              points: product.item_total_points,
            //   image: product.product_image
            //     ? product.product_image
            //     : `${serverAssets}/noimage.png`,
            })));
          }else{
            setMyOrderList([]);
          }
        } else {
            // setLoading(false);
        }
      } catch (e) {
      }
    }

    useEffect(() => {
        if (selectedContractor?.id) {
          getInfluencerOrders();
        }
      }, [selectedContractor]);

    // const handleRaiseTicket = async() =>{
    //     let isValid = true;
    //     const validations = [

    //         // {value: allComplaint, setter: setAllComplaint, message: 'Complaint category is required.' },

    //         {value: raiseTicketInput.issueSummary, setter: setIsSummaryValidationError, message: 'Issue Summary is required.' },
    //         {value: raiseTicketInput.issueDetails, setter: setIsIssueValidationError, message: 'Issue Details is required.' },
    //         // {value: isPriorty.id, setter: setIsComplaintValidationError, message: 'Priority is required' },
    //         {value: isComplaint.id, setter: setIsPriorityValidationError, message: 'Complaint is required'}
    //     ]
    //     validations.forEach(({ value, setter, message }) => {
    //         if (!value) {
    //           setter(message);
    //           isValid = false;
    //         }
    //         else {
    //             setter(''); 
    //         }
    //       });
        
    //         if(isValid){
    //         try{

    //         const token = localStorage.getItem('access_token') 
    //         const formData = new FormData();
    //         if(image) {
    //             formData.append("file_1", image.file);
    //         }
    //         formData.append("summary", raiseTicketInput.issueSummary);
    //         formData.append("description", raiseTicketInput.issueDetails);
    //         formData.append("type", "complaints");
    //         formData.append("subType", "query");
    //         formData.append("status_id", '1'); 
    //         formData.append("status", "open");
    //         formData.append("priorityId", parseInt(isPriorty.id));
    //         formData.append("complaint_categories_id", parseInt(isComplaint.id.toString()));  
    //         formData.append("dcm_complaint_sub_categories_id", isSubComplaint.id.toString());
    //         formData.append("ticket_no", "");

    //         if(myOrderList.length > 0)
    //         {
    //           formData.append("order_id", parseInt(selectedOrder?.id));
    //           formData.append("order_item_id", parseInt(selectedOrder?.unit));
    //         }

    //          setIsButtonLoading(true)
    //          const handleRaiseTicketSubmit  = await HelpDeskServices.createTicket(formData)
    //          setIsButtonLoading(false)
    //          if(handleRaiseTicketSubmit.response_code == 200)
    //          {
    //            toast.success("Ticket raised")
    //             setTimeout(()=>{
    //                 navigate('/helpdesk')
    //             },5000)
    //         }
    //         else{
    //             setIsButtonLoading(false);
    //             toast.error("Failed to raise ticket"); 
    //         }
    //         }
    //         catch(error){
    //             console.error("Raise Ticket")
    //         }
    //    }
    // }

    const handleRaiseTicket = async () => {
      let isValid = true;
      setIsSummaryValidationError('');
      setIsIssueValidationError('');
      setIsComplaintValidationError('');
      setIsPriorityValidationError('');
      setIsSubComplaintValidationError('');
      setIsOrderValidationError('');

      const validations = [
        {
          value: raiseTicketInput.issueSummary,
          setter: setIsSummaryValidationError,
          message: 'Issue Summary is required.',
        },
        {
          value: raiseTicketInput.issueDetails,
          setter: setIsIssueValidationError,
          message: 'Issue Details is required.',
        },
        {
          value: isComplaint?.id,
          setter: setIsComplaintValidationError,
          message: 'Complaint category is required.',
        },
        // {
        //   value: isPriorty?.id,
        //   setter: setIsPriorityValidationError,
        //   message: 'Priority is required.',
        // },
        {
          value: isSubComplaint?.id,
          setter: setIsSubComplaintValidationError,
          message: 'Subcategory is required.',
        },
      ];
    
      validations.forEach(({ value, setter, message }) => {
        if (!value) {
          setter(message);
          isValid = false;
        } else {
          setter('');
        }
      });
    
      if (myOrderList.length > 0) {
        
        if (!selectedOrder?.id || !selectedOrder?.unit) {
          setIsOrderValidationError('Order selection is required.');
          isValid = false;
          
        } else {
          setIsOrderValidationError('');
        }
      }
    
      // Optional: Validate image upload if required
      // if (!image) {
      //   setIsFileValidationError('File is required.');
      //   isValid = false;
      // } else {
      //   setIsFileValidationError('');
      // }
    
      if (isValid) {
        try {
          const token = localStorage.getItem('access_token');
          const formData = new FormData();
    
          if (image) {
            formData.append('file_1', image.file);
          }
    
          formData.append('summary', raiseTicketInput.issueSummary);
          formData.append('description', raiseTicketInput.issueDetails);
          formData.append('type', 'complaints');
          formData.append('subType', 'query');
          formData.append('status_id', '1');
          formData.append('status', 'open');
          formData.append('priorityId', parseInt(isPriorty.id));
          formData.append('complaint_categories_id', parseInt(isComplaint.id.toString()));
          formData.append('dcm_complaint_sub_categories_id', isSubComplaint.id.toString());
          formData.append('ticket_no', '');
    
          if (myOrderList.length > 0) {
            formData.append('order_id', parseInt(selectedOrder?.id));
            formData.append('order_item_id', parseInt(selectedOrder?.unit));
          }
    
          setIsButtonLoading(true);
          const handleRaiseTicketSubmit = await HelpDeskServices.createTicket(formData);
          setIsButtonLoading(false);
    
          if (handleRaiseTicketSubmit.response_code === 200) {
            toast.success('Ticket raised');
            setTimeout(() => {
              navigate('/helpdesk');
            }, 5000);
          } else {
            toast.error('Failed to raise ticket');
          }
        } catch (error) {
          console.error('Raise Ticket Error:');
          setIsButtonLoading(false);
          toast.error('Something went wrong');
        }
      }
    };
    

    const handleFileChange = (file) => {
        setImage(file);
    };

    return (
        <>
         {/* {loading && <Loader/> } */}
          <BreadCrumbSecttion
            pageTitle="Raise A  New Ticket"
            currentPageName="Raise A New Ticket"
          />
          <section className='padTop50'>
            <Container>
              <Row className='justify-content-center align-item-center h-100'>
                <Col xs={12}>
                  <div className='userInfoBox'>
                    <div className='dashboard-title'>
                      <h4>Please Raise Your Ticket</h4>
                    </div>
                    <div className="dashboard-details">
                    {/* <Row>
                        <Col xs = {12}>
                        {loading && <NoData title="fetching.." />}
                        </Col>
                    </Row> */}
                      <Row>
                        <Col xs={12} lg={3}>
                            <SelectDropDown 
                            labelName="Complaint Category"
                            requiredStar= "*"
                            page='searchFilter'
                            options={allComplaint}
                            selectedValue={isComplaint}
                            setSelectedValue={setIsComplaint}
                            onChange={handleCategorySelect}/>
                            {isComplaintValidationError && (
                                <div className="error-message">{isComplaintValidationError}</div>
                            )}
                        </Col>

                        {isComplaint.id && <Col xs={12} lg={3}>
                            <SelectDropDown 
                            labelName="Complaint Subcategory"
                            requiredStar= "*"
                            page='searchFilter'
                            options={allSubcategory}
                            selectedValue={isSubComplaint}
                            setSelectedValue={setIsSubComplaint}
                            onChange={handleSubCategorySelect}/>
                            {isSubComplaintValidationError && (
                                <div className="error-message">{isSubComplaintValidationError}</div>
                            )}
                        </Col>}

                        {contractorList.length > 0 && <Col xs={12} lg={3}>
                            <SelectDropDown 
                            labelName="My Contractors"
                            requiredStar= "*"
                            page='searchFilter'
                            options={contractorList}
                            selectedValue={selectedContractor}
                            setSelectedValue={setSelectedContractor}
                            onChange={handleContractorSelect}/>
                            {isContractorValidationError && (
                                <div className="error-message">{isContractorValidationError}</div>
                            )}
                        </Col>}

                        {myOrderList.length > 0 && <Col xs={12} lg={3}>
                            <SelectDropDown 
                            labelName="My Orders"
                            requiredStar= "*"
                            page='searchFilter'
                            options={myOrderList}
                            selectedValue={selectedOrder}
                            setSelectedValue={setSelectedOrder}
                            // onChange={handleContractorSelect}
                            />
                            {/* {isContractorValidationError && (
                                <div className="error-message">{isContractorValidationError}</div>
                            )} */}

                            {isOrderValidationError && (
                              <span className="error-message">{isOrderValidationError}</span>
                            )}

                        </Col>}
                            
                        {/* <Col xs={12} lg={3}>
                            <SelectDropDown 
                            labelName="Priority Level"
                            requiredStar= "*"
                            options={allPriority}
                            selectedValue={isPriorty}
                            setSelectedValue={setIsPriorty}
                            onChange={handlePriortySelect}/>
                            {isPriorityValidationError && (
                                <div className="error-message">{isPriorityValidationError}</div>
                            )}
                        </Col> */}
                            <Col xs={12} lg={3} className='raise-textarea'>
                            <ThemeTextarea labelName = "Issue Summary"
                            requiredStar= "*"
                            name= "issueSummary"
                            value = {raiseTicketInput.issueSummary}
                            onChange={handleChangeInput}/>
                            {isSummaryValidationError && (
                                <div className="error-message">{isSummaryValidationError}</div>
                            )}
                            </Col>
                            <Col xs={12} lg={3} className='raise-textarea'>
                            <ThemeTextarea labelName = "Issue Details"
                            requiredStar= "*"
                            name= "issueDetails"
                            value = {raiseTicketInput.issueDetails}
                            onChange={handleChangeInput}/>
                            {isIssueValidationError && (
                                <div className="error-message">{isIssueValidationError}</div>
                            )}
                            </Col>
                            <Col xs={12} lg={3} className="raise-textarea">
                                <UploadFile
                                  key={fileInputKey}
                                  label={`Upload file`}
                                  accept="image/jpeg, image/jpg, image/png"
                                  value={image}
                                  setValue={handleFileChange}
                                />
                            </Col>
                        {/* <Col xs={12} lg={3}>
                            <PrimaryGradientButton  
                            buttonText={isButtonLoading ? "Processing..." : "Submit"} 
                            onClick={handleRaiseTicket}
                            disabled={isButtonLoading}/>
                        </Col> */}

                            <Col xs={12}>
                              <div className="d-flex justify-content-end">
                                <div style={{ width: 'auto' }}>
                                  <PrimaryGradientButton  
                                    buttonText={isButtonLoading ? "Processing..." : "Submit"} 
                                    onClick={handleRaiseTicket}
                                    disabled={isButtonLoading}
                                  />
                                </div>
                              </div>
                            </Col>

                        <Col xs={12} lg={9}></Col>
                        <Col xs ={12} lg ={6} className='mt-4'>
                                        
                                            {/* {showAlert && <AlertMsg alertBoxColor={isLoginSuccess.isLogin ? 'successAlert' : 'FailedAlert'}
                                                heading={isLoginSuccess.heading}
                                                text={isLoginSuccess.text}
                                            />
                                            } */}
                                            
                                            
                                        </Col>
                      </Row>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </section>
        </>
      );
    }

export default RaiseTicket